// extracted by mini-css-extract-plugin
export default {"cardds":"Card_cardds__0r1zZ","css-1fzpoyk":"Card_css-1fzpoyk__aV6FY"};